export default __webpack_public_path__ + "static/media/universal-listing.fda97d8e.svg";